import { getPosts } from "../../services/posts";

const state = {
  posts: null,
  bigPost: null,
  hasNext: true,
  rowsPerPage: 4,
  page: 1
};

const getters = {
  posts: state => state.posts,
  rowsPerPage: state => state.rowsPerPage,
  page: state => state.page,
  bigPost: state => state.bigPost,
  hasNext: state => state.hasNext,
  microBlogPosts: state => {
    if (state.posts && state.posts.length > 0) {
      return state.posts.slice(0, 2);
    }
  }
};

const actions = {
  async fetch({ commit, state }) {
    if (!state.posts) {
      const { data } = await getPosts(state.page, state.rowsPerPage);
      const { rows } = data;
      commit("setBigPost", rows[0]);
      commit("setPosts", rows.slice(1, rows.length));
    }
  },
  async fetchNext({ commit, state, dispatch }) {
    const storedPosts = state.posts;
    const { data } = await getPosts(state.page, state.rowsPerPage);
    const { count, rows } = data;
    if (state.page * state.rowsPerPage >= count) {
      commit("setHasNext", false);
    }
    storedPosts.push(...rows);
    commit("setPosts", storedPosts);
  },
  incrementPage({ commit, state }) {
    let page = state.page + 1;
    commit("setPage", page);
  }
};

const mutations = {
  setPosts(state, posts) {
    state.posts = posts;
  },
  setHasNext(state, payload) {
    state.hasNext = payload;
  },
  setBigPost(state, bigPost) {
    state.bigPost = bigPost;
  },
  setPage(state, page) {
    state.page = page;
  },
  setRowsPerPage(state, rowsPerPage) {
    state.rowsPerPage = rowsPerPage;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
